'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCharity = exports.searchCharities = exports.fetchCharity = exports.fetchCharities = exports.c = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var c = exports.c = {
  ENDPOINT: 'v1/charity',
  SEARCH_ENDPOINT: 'v1/onesearch'
};

var fetchCharities = exports.fetchCharities = function fetchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return Promise.reject('This method is not supported for JustGiving');
};

var fetchCharity = exports.fetchCharity = function fetchCharity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.get)(c.ENDPOINT + '/' + id);
};

var searchCharities = exports.searchCharities = function searchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var finalParams = _extends({}, params, {
    i: 'Charity'
  });

  return (0, _client.get)(c.SEARCH_ENDPOINT, finalParams).then(function (response) {
    return response.GroupedResults && response.GroupedResults.length && response.GroupedResults[0].Results || [];
  });
};

var deserializeCharity = exports.deserializeCharity = function deserializeCharity(charity) {
  var id = charity.id || charity.Id;
  var subdomain = (0, _client.isStaging)() ? 'www.staging' : 'www';

  return {
    active: true,
    categories: charity.categories,
    country: charity.countryCode || charity.CountryCode,
    description: charity.description || charity.Description,
    donateUrl: 'https://' + subdomain + '.justgiving.com/onecheckout/donation/direct/' + id,
    email: charity.emailAddress,
    events: charity.EventIds,
    getStartedUrl: 'https://' + subdomain + '.justgiving.com/fundraising-page/creation/?cid=' + id,
    id: charity.id || charity.Id,
    logo: charity.logoAbsoluteUrl || charity.Logo,
    name: charity.name || charity.Name,
    registrationNumber: charity.registrationNumber,
    slug: charity.pageShortName || charity.Link.split('/').pop(),
    url: charity.profilePageUrl
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/charities/justgiving/index.js
// module id = 1318
// module chunks = 0